import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal, Play, PauseCircle, Archive, Trash2, RotateCcw } from "lucide-react";

const STATUS_STYLES = {
  actif: "bg-emerald-50 text-emerald-700 border-emerald-200",
  suspendu: "bg-amber-50 text-amber-700 border-amber-200",
  "archivé": "bg-slate-100 text-slate-600 border-slate-200",
  "supprimé": "bg-rose-50 text-rose-700 border-rose-200",
};

const STATUS_LABEL = {
  actif: "Actif", suspendu: "Suspendu", "archivé": "Archivé", "supprimé": "Supprimé",
};

export function StatusBadge({ status }) {
  const s = status || "actif";
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[s] || STATUS_STYLES.actif}`}
      data-testid={`status-badge-${s}`}
    >
      {STATUS_LABEL[s] || s}
    </span>
  );
}

// Menu d'actions de statut (soft-delete : restaurable 30 jours).
export function StatusMenu({ current, onChange, extra, testid }) {
  const items = [
    { value: "actif", label: "Activer", icon: Play, show: current !== "actif" },
    { value: "suspendu", label: "Suspendre", icon: PauseCircle, show: current !== "suspendu" },
    { value: "archivé", label: "Archiver", icon: Archive, show: current !== "archivé" },
  ].filter((i) => i.show);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="rounded-lg border border-slate-200 p-1.5 text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-900"
          data-testid={testid}
        >
          <MoreHorizontal size={16} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {extra}
        {extra && <DropdownMenuSeparator />}
        {items.map((i) => (
          <DropdownMenuItem key={i.value} onClick={() => onChange(i.value)} data-testid={`action-${i.value}`}>
            <i.icon size={15} className="mr-2" /> {i.label}
          </DropdownMenuItem>
        ))}
        {current === "supprimé" ? (
          <DropdownMenuItem onClick={() => onChange("actif")} data-testid="action-restore">
            <RotateCcw size={15} className="mr-2" /> Restaurer
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={() => onChange("supprimé")}
            className="text-rose-600 focus:text-rose-700"
            data-testid="action-delete"
          >
            <Trash2 size={15} className="mr-2" /> Supprimer
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl" data-testid="admin-page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-1.5 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
